import React from "react";
import SystemPage from "pages/Admin/Settings/SystemPage"
import Facing from "services/Admin/FacingService"

const FacingPage = (props) => {
        return <SystemPage
                Service={Facing}
                type={"Facing"}
                placeholder={"facing"}
                meta={"Facing"}
                header={"Facing"}
                hasSub={false}
        />

}

export default FacingPage;
